import { render, staticRenderFns } from "./channel-bbb.vue?vue&type=template&id=0d2a7602&lang=pug&"
import script from "./channel-bbb.vue?vue&type=script&lang=js&"
export * from "./channel-bbb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports